import React, { useState } from 'react';
import { configData2 } from './ConfigComponents';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ConfigForm from './ConfigForm';
import OldConfigForm from './OldConfigForm';

interface UiConfigDashboardProps {
    optionKey: string;
}

const UiConfigDashboard: React.FC = () => {
    const [activeOptionKey, setActiveOptionKey] = useState<string | null>("catalogue_configuration");

    const mapOptionKeyToLabel = (optionKey: string) => {
        switch (optionKey) {
            case 'authentication_configuration':
                return 'Auth';
            case 'cart_configuration':
                return 'Cart';
            case 'checkout_configuration':
                return 'Checkout';
            case 'catalogue_configuration':
                return 'Catalogue';
            case 'language_configuration':
                return 'Language';
            case 'order_configuration':
                return 'Order';
            case 'order_tracking_configuration':
                return 'Order Tracking';
            case 'app_configuration':
                return 'App';
            case 'theme_configuration':
                return 'Theme';
            case 'customer_configuration':
                return 'Customer';
            case 'filters_label_configuration':
                return 'Filters';
            case 'sfa_configurations':
                return 'SFA';
            default:
                return optionKey;
        }
    };

    const handleClick = (optionKey: string) => {
        setActiveOptionKey(optionKey);
    };


    return (
        <div className="main_container">
            <div className="ui_sidebar">
                {configData2.length > 0 && <div className="sidebar_header">
                    <h5>CONFIGURATION MENU</h5>
                </div>}
                <div className='config_option_container' style={{display:"flex",justifyContent:"center",width:"100%",paddingBlock:"20px"}}>
                    {Object.keys(configData2).length > 0 && (
                        <div className="options_container" style={{gridGap:"20px"}}>
                            {Object.keys(configData2).map((optionKey, index) => {
                                const option = configData2[optionKey];
                                return (
                                    <div key={index} className={`uisidebar_option ${optionKey === activeOptionKey ? 'uiconfig_active_option' : ''}`} onClick={() => handleClick(optionKey)}>
                                        <span>{mapOptionKeyToLabel(optionKey)}</span>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            </div>
            <div className="content_container" style={{width:"80%"}}>
                {activeOptionKey && (
                    <>
                     <ConfigForm
                    activeOptionKey={activeOptionKey}
                     />
                    {/* <OldConfigForm
                    activeOptionKey={activeOptionKey}
                    /> */}
                    </>
                    
                )}
            </div>
        </div>
    );
};
export default UiConfigDashboard;
